import Modal from 'components/Luxkit/Modal/Modal'
import React, { useContext } from 'react'
import styled from 'styled-components'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import { rem } from 'polished'
import TextButton from 'components/Luxkit/Button/TextButton'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ContactContext from 'contexts/contactContext'

const StyledContactDiv = styled.div`
  background: ${props => props.theme.palette.neutral.seven};
  padding: ${rem(20)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const StyledDisclaimerTextBlock = styled(BodyTextBlock)`
  margin-top: ${rem(4)};
  margin-bottom: ${rem(16)};
  max-width: 80%;
`

function DisclaimerModal() {
  const currentContact = useContext(ContactContext)
  const defaultContact = currentContact.defaultContact

  return <Modal title="Disclaimer">
    <VerticalSpacer gap={20}>
      <BodyTextBlock variant="large">
        Information provided in this chat is general in nature and may not apply to your particular booking - such information should not be relied upon for the purposes of making a booking.
        <br/>
        <br/>
        For guaranteed up to date and relevant information relating to a particular offer or the booking process please contact us.
      </BodyTextBlock>
      <StyledContactDiv>
        <BodyTextBlock variant="large" weight="bold" align="center">
          Need help? Call our support team
        </BodyTextBlock>
        <StyledDisclaimerTextBlock variant="medium" align="center">
          Our customer service team are available anytime, 24 hours, 7 days a week
        </StyledDisclaimerTextBlock>
        <TextButton kind="secondary" href={`tel:${defaultContact.humanReadable}`}>{defaultContact.humanReadable}</TextButton>
      </StyledContactDiv>
    </VerticalSpacer>
  </Modal>
}

export default DisclaimerModal
